import { Timeline } from '@crispico/react-timeline-10000';
import PropTypes from 'prop-types';
import { DragAndDropController } from './DragAndDropController';
import { Droppable } from '@crispico/foundation-react/components/DragAndDrop/DragAndDrop';
import { isFlexMode } from 'app';
import { Utils } from "@crispico/foundation-react/utils/Utils";
import { TestsAreDemoCheat } from "@famiprog-foundation/tests-are-demo";

export default class XopsTimeline extends Timeline {

    static propTypes = {
        ...Timeline.propTypes,
        droppableProps: PropTypes.shape({
            draggable: PropTypes.bool,
            item: PropTypes.object,
        })
    }

    static defaultProps = {
        ...Timeline.defaultProps,
        droppableProps: {
            draggable: false,
            item: {},
        }
    }

    setTimelineStartEndDateHelperTad(startHour, endHour) {
        this.setState({
            startDate: moment(Utils.now()).startOf("day").hour(startHour).valueOf(),
            endDate: moment(Utils.now()).startOf("day").hour(endHour).valueOf()
        });
    }

    get selectedItems() {
        return this._selectionHolder ? this._selectionHolder.state.selectedItems : [];
    }

    renderMenuButton() {
        return null;
    }

    renderGanttPart({ bodyHeight, timebarHeight }) {
        const { draggable, item } = this.props.droppableProps;
        if (draggable) {
            return <Droppable className="flex-container flex-grow" item={item} accept={DragAndDropController.INSTANCE.getAcceptedType(item.entityUid)} canDrop={isFlexMode() ? undefined : DragAndDropController.INSTANCE.canDrop} drop={isFlexMode() ? undefined : DragAndDropController.INSTANCE.onDrop}>
                {super.renderGanttPart({ bodyHeight, timebarHeight })}
            </Droppable>
        }
        return super.renderGanttPart({ bodyHeight, timebarHeight });
    }

    render() {
        return <>
            <TestsAreDemoCheat objectToPublish={this} />
            {super.render()}
        </>
    }
}
